var _indexOf = /*#__PURE__*/require('./_indexOf');

function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
}
module.exports = _contains;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_contains.js
// module id = 156
// module chunks = 0